var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3935_20299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84863 17.9688C5.54895 17.9688 6.11426 17.4034 6.11426 16.7031V15.4375H14.5518V16.7031C14.5518 17.4034 15.1171 17.9688 15.8174 17.9688C16.5177 17.9688 17.083 17.4034 17.083 16.7031V14.5938C17.083 13.6656 16.3236 12.9062 15.3955 12.9062H5.27051C4.34238 12.9062 3.58301 13.6656 3.58301 14.5938V16.7031C3.58301 17.4034 4.14832 17.9688 4.84863 17.9688ZM17.083 8.6875H17.9268C18.3908 8.6875 18.7705 9.06719 18.7705 9.53125V10.375C18.7705 10.8391 18.3908 11.2188 17.9268 11.2188H17.083C16.6189 11.2188 16.2393 10.8391 16.2393 10.375V9.53125C16.2393 9.06719 16.6189 8.6875 17.083 8.6875ZM2.73926 8.6875H3.58301C4.04707 8.6875 4.42676 9.06719 4.42676 9.53125V10.375C4.42676 10.8391 4.04707 11.2188 3.58301 11.2188H2.73926C2.2752 11.2188 1.89551 10.8391 1.89551 10.375V9.53125C1.89551 9.06719 2.2752 8.6875 2.73926 8.6875ZM14.5518 11.2188H6.11426V4.46875C6.11426 3.54062 6.87363 2.78125 7.80176 2.78125H12.8643C13.7924 2.78125 14.5518 3.54062 14.5518 4.46875V11.2188Z",
    fill: "#0C0900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3935_20299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 20.25,
    fill: "white",
    transform: "translate(0.208008 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.ed36d2cba2005933eafb12dec050898d.svg";
export { ForwardRef as ReactComponent };